import eventApi from '@/common/eventapi'
export default {
  menus: [
    {
      title: '主数据维护',
      icon: 'mdi-apps',
      to: '/data',
      role: 'master-view'
    },
    {
      title: '系统管理',
      icon: 'mdi-settings',
      to: '/system',
      role: 'config-view'
    },
    {
      title: '报表',
      icon: 'mdi-finance',
      to: '/report',
      role: 'report-view'
    },
    {
      title: '审计追踪',
      icon: 'mdi-alert-circle',
      to: '/audit',
      role: 'log-view'
    }
  ],
  loginuser: {
    Roles: ['master-view', 'master-modify', 'config-view', 'config-modify'],
    password: null,
    userName: null,
    token: null
  },
  eventdom: new eventApi(),
  confirmDialog: null
}
